import script from "./theme-mode-icon.vue?vue&type=script&setup=true&lang=ts"
export * from "./theme-mode-icon.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__